import React from 'react'

export default function ArrowLeft({ className, color }) {
    return (
        <svg
            className="w-6 h-6 text-[#6F6C99] "
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 20">
<path d="M16 4L7 12.5L16 21" stroke="#0071BC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
